import {POST} from '../../../modules/fetch.ts';
import type {Store} from '../../store.ts';

/**
 * Handles the logic for the viewed checkbox by updating state in the current store and the backend.
 */
export function initViewedCheckboxListener(store: Store): () => void | undefined {
  // add an event listener to make sure the viewed property of the file is updated
  const labelElem = document.querySelector('.viewed-file-form');
  if (labelElem) {
    const updateVisibility = (e: Event) => {
      const viewedStyleClass = 'viewed-file-checked-form';

      const checkboxElem = e.target as HTMLInputElement;
      const viewed = checkboxElem.checked;

      // update the styles of the preview portion of the UI
      if (viewed) {
        labelElem.classList.add(viewedStyleClass);
        checkboxElem.setAttribute('checked', '');
      } else {
        labelElem.classList.remove(viewedStyleClass);
        checkboxElem.removeAttribute('checked');
      }

      // update the file tree state
      const fileTreeItem = store.hashToPathMap.value.get(store.activeHash.value);
      if (fileTreeItem !== undefined) {
        fileTreeItem.isViewed = checkboxElem.checked;
      } else {
        console.warn('Could not find file tree item for path:', store.activeHash.value);
      }

      // update the backend to mark the file as viewed
      const url = labelElem.getAttribute('data-link');
      const headCommitSHA = labelElem.getAttribute('data-headcommit');
      const fileName = checkboxElem.getAttribute('name');

      const data: {files: Record<string, boolean>, headCommitSHA?: string} = {files: {}};
      data.files[fileName] = viewed;
      if (headCommitSHA !== null) {
        data.headCommitSHA = headCommitSHA;
      }

      POST(url, {data});
    };

    labelElem.addEventListener('input', updateVisibility);
    const cleanup = () => labelElem.removeEventListener('input', updateVisibility);
    return cleanup;
  }
}
